<template>
    <section>
        <h3 class="text-center">Customer Sources</h3>

        <div class="well">
          <form class="form-inline" @submit.prevent="applyDates">
            <div class="form-group" style="margin-right: 10px;">
              <label for="cs-start-date">Start Date</label>
              <input type="date" id="cs-start-date" class="form-control" v-model="startDate" :max="endDate" data-testid="customer-sources-start-date" />
            </div>
            <div class="form-group" style="margin-right: 10px;">
              <label for="cs-end-date">End Date</label>
              <input type="date" id="cs-end-date" class="form-control" v-model="endDate" :min="startDate" data-testid="customer-sources-end-date" />
            </div>
            <button type="submit" class="btn btn-dc" :disabled="!hasBothDates" data-testid="customer-sources-apply">Apply</button>
            <button type="button" class="btn btn-default" @click="showAllTime" data-testid="customer-sources-all-time">All Time</button>
          </form>
        </div>

        <div v-if="error" class="alert alert-danger">{{ error }}</div>

        <section style="display: flex; justify-content: center;" v-if="loading === false && !error">
          <Bar
              :options="chartOptions"
              :data="chartData"
            />
        </section>

        <div class="table-responsive" v-if="loading === false && !error">
          <p class="text-muted">
            These are customers' own answers. A customer's orders count under the first answer they gave,
            and shop, staff and student portal orders are all included.
          </p>
          <table class="table table-striped table-hover" data-testid="customer-sources-table">
            <thead>
              <tr>
                <th>Answer</th>
                <th>Customers</th>
                <th>Orders</th>
                <th>Order Value</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="source in customerSources" :key="source.id">
                <td>{{ source.name }}</td>
                <td>{{ source.customers_count.toLocaleString() }}</td>
                <td>{{ source.orders.toLocaleString() }}</td>
                <td>{{ inDollars(source.order_value) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

    </section>
</template>
<script>
import { Bar } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';
import { inDollars } from '../../../../DriveScout/Billing/Teller';

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
    name: 'CustomerSources',
    components: { Bar },
    data() {
        return {
            customerSources: [],
            loading: true,
            error: '',
            startDate: '',
            endDate: '',
            chartOptions: {
                responsive: true,
                maintainAspectRatio: true
            }
        }
    },
    methods: {
        inDollars,
        getCustomerSources(filters = {}) {
            this.loading = true;
            this.error = '';
            this.$store.dispatch('GET_CUSTOMER_SOURCES', filters).then(response => {
                this.customerSources = response.customer_sources;
                this.loading = false;
            }).catch(() => {
                this.error = 'Failed to load customer sources.';
                this.loading = false;
            });
        },
        applyDates() {
            this.getCustomerSources({ start_date: this.startDate, end_date: this.endDate });
        },
        showAllTime() {
            this.startDate = '';
            this.endDate = '';
            this.getCustomerSources();
        }
    },
    created()
    {
      this.getCustomerSources();
    },
    computed:{
      // The API refuses one date on its own
      hasBothDates() {
          return this.startDate !== '' && this.endDate !== '';
      },
      chartData(){
          return {
              labels: this.customerSources.map(source => source.name),
              datasets: [ { label: `Customer Sources`, data: this.customerSources.map(source => source.customers_count) } ]
          }
      }
    }
}
</script>
<style scoped>

</style>
